import { render, staticRenderFns } from "./selecionar-contato-confirmacao.vue?vue&type=template&id=45bfbc0a&scoped=true"
import script from "./selecionar-contato-confirmacao.vue?vue&type=script&lang=js"
export * from "./selecionar-contato-confirmacao.vue?vue&type=script&lang=js"
import style0 from "./selecionar-contato-confirmacao.vue?vue&type=style&index=0&id=45bfbc0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bfbc0a",
  null
  
)

export default component.exports